var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadfileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 5.49951L4.18934 13.4393C3.90804 13.7206 3.75 14.1021 3.75 14.5C3.75 14.8978 3.90804 15.2793 4.18934 15.5606C4.47064 15.8419 4.85218 16 5.25 16C5.64783 16 6.02936 15.8419 6.31066 15.5606L15.6208 6.12083C15.8993 5.84226 16.1203 5.51154 16.2711 5.14756C16.4219 4.78359 16.4995 4.39348 16.4995 3.99951C16.4995 3.60555 16.4219 3.21544 16.2711 2.85146C16.1203 2.48748 15.8993 2.15677 15.6208 1.87819C15.3422 1.59962 15.0115 1.37864 14.6475 1.22787C14.2835 1.07711 13.8934 0.999512 13.4995 0.999512C13.1055 0.999512 12.7154 1.07711 12.3514 1.22787C11.9874 1.37864 11.6567 1.59962 11.3781 1.87819L2.06802 11.318C1.22411 12.1619 0.75 13.3065 0.75 14.5C0.75 15.6934 1.22411 16.838 2.06802 17.682C2.91193 18.5259 4.05653 19 5.25 19C6.44348 19 7.58807 18.5259 8.43198 17.682L16.1245 9.99951",
    stroke: "#0088CC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadfileIcon);
export default __webpack_public_path__ + "static/media/uploadfile-icon.9341fdfbe351cdd1f44f99471e2efc7d.svg";
export { ForwardRef as ReactComponent };